import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-12d5df83")
const _hoisted_1 = { id: "layout-component" }
const _hoisted_2 = { id: "layout-canvas-wrap" }
const _hoisted_3 = ["width", "height"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTitle = _resolveComponent("ToolTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ToolTitle, { title: _ctx.title }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("canvas", {
        id: "layout-canvas",
        ref: "layoutCanvasRef",
        width: _ctx.canvasWidth,
        height: _ctx.canvasHeight
      }, null, 8, _hoisted_3)
    ])
  ]))
}